import { FC, Fragment } from 'react';

import { Grid, Typography } from '@mui/material';
import { css, styled } from '@mui/material/styles';

import { SearchAndHighlightResult } from 'hooks/useSearchAndHighlight.types';

import { Highlighter } from 'components/UIkit/atoms/HighlightText/Highlighter';
import { TextWithPartialHighlight } from 'components/UIkit/atoms/HighlightText/TextWithPartialHighlight';

interface HighlightBySearchValueProps {
  name: string;
  searchValue: string;
  keywords: string[];
}

export const HighlightBySearchValue: FC<HighlightBySearchValueProps> = ({
  name,
  searchValue,
  keywords
}) => (
  <Grid container flexDirection="column">
    <Typography variant="form-text">
      <Highlighter searchValue={searchValue} textToHighlight={name} />
    </Typography>
    {keywords.length > 0 && (
      <StyledKeywords className="keywords">
        {keywords.map((keyword, index) => (
          <Fragment key={keyword}>
            <Highlighter searchValue={searchValue} textToHighlight={keyword} />
            {index + 1 < keywords.length && ', '}
          </Fragment>
        ))}
      </StyledKeywords>
    )}
  </Grid>
);

export const HighlightBySearchResult = ({ name, keywords }: SearchAndHighlightResult) => {
  return (
    <Grid container flexDirection="column">
      <Typography variant="form-text">
        <TextWithPartialHighlight parts={name} />
      </Typography>
      {keywords && keywords.length > 0 && (
        <StyledKeywords className="keywords">
          {keywords.map((keyword: any, index: number) => (
            <Fragment key={keyword.value}>
              <TextWithPartialHighlight parts={keyword} />
              {index + 1 < keywords.length && ', '}
            </Fragment>
          ))}
        </StyledKeywords>
      )}
    </Grid>
  );
};

export const StyledKeywords = styled('span')(
  ({ theme }) => css`
    color: ${theme.palette.text.disabled};
  `
);
